import { Button, Card, Table, Tooltip } from "antd";
import styles from "../../MasterManagement/index.module.less";
import { useAllUsersReport } from "./index.hook";
import Loading from "../../common/Loading";
import { TableHelper } from "../../../util/TableHelper";
import MultiFunctionDateFilter from "../../common/MultiFunctionDateFilter";

import type { ColumnsType } from "antd/lib/table";
import type { AllUsersReportData } from "../../../shared/interface/Report/allUsersReport.interface";
import CircularProgressBar from "../../common/CircularProgressBar";
import { FilePdfOutlined } from "@ant-design/icons";

const AllUsersReport = () => {
  const config = useAllUsersReport();

  const columns: ColumnsType<AllUsersReportData> = [
    {
      align: "left",
      title: "Sr No.",
      key: "sr_no",
      dataIndex: "sr_no",
      sorter: {
        compare: TableHelper.digitSorter("sr_no")
      },
      render: (text, record, index) => index + 1,
      width: "7%"
    },
    {
      align: "left",
      title: "KeyFob",
      key: "key_fob_token",
      dataIndex: "key_fob_token",
      sorter: {
        compare: TableHelper.digitSorter("key_fob_token")
      },
      render: TableHelper.renderText
    },
    {
      align: "center",
      title: "Vehicle Number",
      key: "vehicle_number",
      dataIndex: "vehicle_number",
      sorter: {
        compare: TableHelper.valueCompare("vehicle_number")
      },
      render: TableHelper.renderText
    },
    {
      align: "left",
      title: "Parked By",
      key: "parkedBy",
      dataIndex: "parkedBy",
      sorter: {
        compare: TableHelper.valueCompare("parkedBy")
      },
      render: TableHelper.renderText
    },
    {
      align: "center",
      title: "In Time",
      key: "in_time",
      dataIndex: "in_time",
      sorter: {
        compare: TableHelper.dateSorter("in_time")
      },
      render: TableHelper.renderText
    },
    {
      align: "left",
      title: "Retrieved By",
      key: "retrievedBy",
      dataIndex: "retrievedBy",
      sorter: {
        compare: TableHelper.valueCompare("parkedBy")
      },
      render: TableHelper.renderText
    },
    {
      align: "center",
      title: "Out Time",
      key: "out_time",
      dataIndex: "out_time",
      sorter: {
        compare: TableHelper.dateSorter("out_time")
      },
      render: TableHelper.renderText
    },
    {
      align: "center",
      title: "Duration",
      key: "booking_retrieval_time_diff",
      dataIndex: "booking_retrieval_time_diff",
      sorter: {
        compare: TableHelper.valueCompare("booking_retrieval_time_diff")
      },
      render: TableHelper.renderText
    }
  ];

  return (
    <Card
      className="gx-card card--height"
      title={
        <div className={`gx-title-container`}>
          <span className="card-title-style">ALL USERS PARKING REPORT</span>

          <div>
            <div className={styles["filters-container"]}>
              <MultiFunctionDateFilter setFromDate={config.setStartDate} setToDate={config.setEndDate} />
              <Button type="primary" disabled={!config.setStartDate || !config.endDate} className="gx-mb-0 gx-ml-2 gx-mr-0" onClick={config.fetchAllUsersReportData}>
                Go
              </Button>
              <Tooltip title="Download PDF File">
                <div onClick={config.allUsersData?.length === 0 ? undefined : config.handleExportPDFFile}>{config.allUsersData?.length === 0 ? <FilePdfOutlined className={styles["pdf-icon-disabled"]} /> : config?.pdfIconLoading ? <CircularProgressBar /> : <FilePdfOutlined className={styles["pdf-icon"]} />}</div>
              </Tooltip>
            </div>

            <div className={styles["show-date-filter-value"]}>
              <span className="gx-mr-5">
                From Date: &nbsp;<strong>{config?.startDate ?? ""}</strong>
              </span>
              <span>
                To Date: &nbsp;<strong>{config?.endDate ?? ""}</strong>
              </span>
            </div>
          </div>
        </div>
      }
    >
      {config.loading ? (
        <Loading />
      ) : (
        <Table //
          size="middle"
          className="gx-table-responsive"
          columns={columns}
          dataSource={config.allUsersData}
          pagination={config.pagination}
          onChange={config.handleChangePagination}
          rowKey={(record) => record.id}
          bordered
        />
      )}
    </Card>
  );
};

export default AllUsersReport;
